var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoBenefitsIconBkg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 96,
    viewBox: "0 0 120 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120 58.1995C120 81.8338 69.5053 95.858 44.7761 95.858C20.047 95.858 0 76.6986 0 53.0643C0 29.4299 37.9574 0 62.6866 0C87.4157 0 120 34.5652 120 58.1995Z",
    fill: "#DEE7FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoBenefitsIconBkg);
export default __webpack_public_path__ + "static/media/noBenefitsIconBkg.ba67ecc56afd3dc13cdc9f477b443daf.svg";
export { ForwardRef as ReactComponent };